import React, { useState } from "react";
import styled from "styled-components";
import HeaderOne from "../../components/parts/HeaderOne";
import RadioButton from "../../components/parts/RadioButton";
import UserHead from "../../config/UserHead";
import OwnerLayout from "../../components/layouts/OwnerLayout";
import AddNewShopForm from "../../components/combinations/Owner/AddNewShopForm";
import AddExistShopForm from "../../components/combinations/Owner/AddExistShopForm";
import Annotation from "../../components/parts/Annotation";

const CreateShopStyle = styled.div`
  background: white;
  border-radius: 25px;
  text-align: center;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    padding: 20px 0;
    margin: 30px 10px;
  }
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin-bottom: 20px;
`;

const AnnotationStyle = styled.div`
  background: none;
  text-align: center;
  max-width: 600px;
  margin: 0 auto 0 auto;

  @media (max-width: 767px) {
    padding: 0 10px;
  }
`;

const RadioButtonGroupStyle = styled.div`
  background: none;
  text-align: center;
  max-width: 600px;
  margin: 0 auto 0 auto;

  @media (max-width: 767px) {
    padding: 0 10px;
  }
`;

const AddShop: React.FC = () => {
  const [checkedValue, setCheckedValue] = useState<string>("exist");

  return (
    <OwnerLayout>
      <UserHead title="オーナー店舗追加申請" />
      <CreateShopStyle>
        <HeaderOneStyle>オーナー店舗追加申請</HeaderOneStyle>
        <AnnotationStyle>
          <Annotation level="default" mb="20px">
            送信後、Cafect運営で審査を行います。<br />
            審査は数日から2週間程度お時間をいただきます。<br />
            審査完了まで今しばらくお待ちください。
          </Annotation>
        </AnnotationStyle>
        <RadioButtonGroupStyle>
          <RadioButton
            selection={[
              { label: "新規店舗の追加", value: "new" },
              { label: "既存店舗から追加", value: "exist" },
            ]}
            checkedValue={checkedValue}
            setCheckedValueAction={setCheckedValue}
          />
        </RadioButtonGroupStyle>
        {checkedValue === "new" && <AddNewShopForm />}
        {checkedValue === "exist" && <AddExistShopForm />}
      </CreateShopStyle>
    </OwnerLayout>
  );
};
export default AddShop;
